/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

// TODO: abstract upload API
import birdata from "../api.js";

function createStyleButton(attribute, label, editor) {
	var button = document.createElement('button');
	button.textContent = label;
	button.className = attribute;

	var tag, on, off;
	switch(attribute) {
		case 'bold':
			tag = 'B';
			on = 'bold';
			off = 'removeBold';
			break;
		case 'italic':
			tag = 'I';
			on = 'italic';
			off = 'removeItalic';
			break;
		case 'underline':
			tag = 'U';
			on = 'underline';
			off = 'removeUnderline';
			break;
	}

	if(tag) {
		button.addEventListener('click', function() {
			if(editor.hasFormat(tag)) {
				editor[off]();
			} else {
				editor[on]();
			}
		});

		editor.addEventListener('pathChange', function() {
			if(editor.hasFormat(tag)) {
				button.classList.add('on');
			} else {
				button.classList.remove('on');
			}
		});
	}

	return button;
}

function setupEditorUI(toolbarNode, editor) {
	var styleButtons = [
		createStyleButton('bold', 'B', editor),
		createStyleButton('italic', 'I', editor),
		createStyleButton('underline', 'U', editor),
	];

	for(var i = 0; i < styleButtons.length; i++) {
		toolbarNode.appendChild(styleButtons[i]);
	}

	var imageButton = document.createElement('button');
	imageButton.textContent = 'Insert Image';
	imageButton.addEventListener('click', function() {
		var input = document.createElement('input');
		input.setAttribute('style', 'display: none');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/gif, image/jpeg, image/png');
		document.body.appendChild(input);
		input.addEventListener('change', function() {
			if(input.files && input.files.length > 0) {
				var file = input.files[0];
				birdata.upload(file).then(function(url) {
					editor.insertImage(url);
				});
			}
			document.body.removeChild(input);
		});
		input.click();
	});

	toolbarNode.appendChild(imageButton);
}

export default setupEditorUI;